import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { engineerService, EngineerJob } from '../../services/engineerService';

function formatDate(iso?: string | null) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString([], {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
}

const EngineerUpcoming: React.FC = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['engineer', 'upcoming'],
    queryFn: () => engineerService.getUpcoming(30),
    refetchInterval: 120_000,
  });

  return (
    <div className="max-w-xl mx-auto px-4 py-4 space-y-3">
      <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">Upcoming</div>

      {isLoading && <div className="text-sm text-slate-500">Loading…</div>}

      {data && data.length === 0 && (
        <div className="bg-white border border-slate-200 rounded-xl p-6 text-center">
          <div className="text-sm font-semibold text-slate-700">Nothing upcoming</div>
        </div>
      )}

      {data?.map((job: EngineerJob) => (
        <Link
          key={job.id}
          to={`/engineer/jobs/${job.id}`}
          className="block bg-white border border-slate-200 rounded-xl p-4 shadow-sm hover:border-blue-300"
        >
          <div className="text-xs text-slate-500">{formatDate(job.scheduledDate)}</div>
          <div className="mt-1 text-base font-semibold text-slate-900 line-clamp-2">{job.title}</div>
          <div className="mt-0.5 text-sm text-slate-600 truncate">{job.client?.name}</div>
          {job.address && (
            <div className="mt-0.5 text-xs text-slate-500 truncate">{job.address}</div>
          )}
        </Link>
      ))}
    </div>
  );
};

export default EngineerUpcoming;
